import React from 'react'
import Form from '../Form/index'
import { useLocation } from 'react-router-dom'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import { APP_CONSTANTS } from 'src/consumer/constants'

export default function Onboarding() {
  const { state } = useLocation()

  return (
    <>
      <SEOComponent
        title="Create an Account with AUMHUM"
        description={APP_CONSTANTS.DEFAULT_DESCRIPTION}
        image={APP_CONSTANTS.APP_LOGO_LINK}
        keywordsArr={['account', 'signup', 'create']}
      />
      <Form state={state} />
    </>
  )
}
